import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import RelationshipForm from '../containers/RelationshipFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class RelationshipAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `RelationshipAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('relationship_route_add')} />
          <RelationshipForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default RelationshipAddScreen;

Logger.log('silly', `RelationshipAddScreen loaded.`);
